module.exports = __webpack_public_path__ + "media/bootstrap-icons/snow3-cb02450b.svg";